// ServiceSection.js
import React from "react";
import Header from "../Header"; // adjust path as needed
import { Box, Container, Typography } from "@mui/material";
import ServiceSection from "./DetailedService"; // <-- The services component we created
import About from "../About";

const Service = () => {
  return (
    <>
      <Header />
      <Box
       id="service-0"
       sx={{
        scrollMarginTop: "100px",
       }}
       mt={18} mb={6}>
        <Container>
          <Typography
         
           variant="h4" fontWeight="bold" align="center" gutterBottom>
            Our Services
          </Typography>
          <ServiceSection /> {/* Component from earlier with service cards/images */}
        </Container>
      </Box>
      <About/>
      {/* <Footer /> */}
    </>
  );
};

export default Service;
